import React from "react";
import StatWrapper from "../shared/StatWrapper";
import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import JulesBookshelf from "components/svgs/jules/JulesBookshelf";
import { UserStatsPageProps } from "pages/clientverse/users/stats/index.props";
import { usePage } from "@inertiajs/react";

interface OwnedBooksStatProps {
  size?: "sm" | "md" | "lg" | "xl";
}

const OwnedBooksStat: React.FC<OwnedBooksStatProps> = ({ size }) => {
  const { isOwner, user, stats } = usePage<UserStatsPageProps>().props;
  const { ownedBreakdown: data } = stats;

  if (!data) {
    return (
      <StatWrapper title="Owned Books" size={size}>
        <div className="relative h-full w-full">
          <Heading size="sm" className="mb-2">
            {isOwner ? "Your" : `${user.name}'s`} owned books data is not
            available
          </Heading>
        </div>
      </StatWrapper>
    );
  }

  const totalOwnedBooksCount = data.totalOwnedBooksCount || 0;
  const newlyOwnedBooksCount = data.newlyOwnedBooksCount || 0;
  const newlyOwnedPercentageRead = data.newlyOwnedPercentageRead || 0;
  const isLifetime = stats.selectedPeriod === 'life';

  return (
    <StatWrapper title="Owned Books" size={size}>
      <div className="relative h-full w-full">
        <Heading size="sm" className="mb-2">
          {isLifetime 
            ? `${isOwner ? "Your" : `${user.name}'s`} owned library`
            : `Changes in ${isOwner ? "your" : `${user.name}'s`} owned library`
          }
        </Heading>
        <div className="flex flex-col gap-4">
          {!isLifetime && (
            <div>
              <Text size="md" variant="secondary">
                Books marked as owned in this period
              </Text>
              <br />
              <Text className="font-bold text-4xl">
                {newlyOwnedBooksCount.toLocaleString()}
              </Text>
            </div>
          )}
          <div>
            <Text size="md" variant="secondary">
              Total books marked as owned
            </Text>
            <br />
            <div className="flex items-center gap-2">
              <Text className="font-bold text-4xl">
                {totalOwnedBooksCount.toLocaleString()}
              </Text>
            </div>
          </div>
          <div>
            <Text size="md" variant="secondary">
              Percentage of newly owned books that you've read
            </Text>
            <br />
            <Text className="font-bold text-4xl">
              {newlyOwnedPercentageRead.toFixed(1)}%
            </Text>
          </div>
        </div>
        <div className="absolute bottom-0 right-0">
          <JulesBookshelf className="w-28 h-auto -mb-4" />
        </div>
      </div>
    </StatWrapper>
  );
};

export default OwnedBooksStat;
